import GrowingIcon from "../Icon/GrowingIcon";
import HotIcon from "../Icon/HotIcon";
import LuckyCloverIcon from "../Icon/LuckyCloverIcon";
import VeryHotIcon from "../Icon/VeryHotIcon";

// Hotness ramp glyph keyed to fill `percentage` (0–100): 🍀 barely started → 🌱 growing →
// 🌶️ very hot → 🔥 almost full. All glyphs at 16px — no size jump between bands.
// chunk 13: the old SignalIcon heat bars were dropped (they re-encoded fill %, a duplicate of
// the pie). This is now the glyph only, returned as a fragment so it renders inline inside the
// fill cluster in GroupItem rather than in its own wrapper span.
const GroupProcess = ({ percentage }: any) => {
  const fill = percentage ?? 0;
  return (
    <>
      {fill < 50 && <LuckyCloverIcon size="16px" />}
      {fill >= 50 && fill < 80 && <GrowingIcon size="16px" />}
      {fill >= 80 && fill < 90 && <VeryHotIcon size="16px" />}
      {fill >= 90 && <HotIcon size="16px" />}
    </>
  );
};

export default GroupProcess;
